// React
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';

// View
import { ProposalsByPlanPage } from './view';

export const ProposalsByPlan = () => {
  const [plans, setPlans] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);

  const { sellers, getSellers, categoryPlans, getCategoryPlans } =
    ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const getProposalStatus = useCallback(async () => {
    await api.get('/proposal/get-status').then((status) => {
      setStatusOptions(createData(status));
    });
  }, []);

  const getPlansByCategory = useCallback(async (id) => {
    await api.get(`register/plan-by-category/${id}`).then((plans) => {
      if (plans.data) {
        setPlans(plans.data);
      }
    });
  }, []);

  const resetPlanInput = () => {
    if (validation.values.planInput) {
      validation.handleChange({
        target: {
          name: 'planInput',
          value: {
            label: '',
            value: '',
          },
        },
      });
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      periodType: 'sale',
      sellerInput: '',
      categoryPlanInput: '',
      planInput: '',
      proposalSituationInput: [],
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string(),
      periodEnds: Yup.string(),
      periodType: Yup.string(),
      sellerInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      categoryPlanInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      planInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      proposalSituationInput: Yup.array(),
    }),

    onSubmit: (values) => {
      let proposalStatusArray = values.proposalSituationInput.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        periodType: values.periodType || null,
        seller_id: values.sellerInput.value || null,
        plan_category_id: values.categoryPlanInput.value || null,
        plan_id: values.planInput.value || null,
        proposal_status_id: proposalStatusArray || null,
      };

      toggleLoading();
      api
        .create('/reports/proposal/by-plan', valuesToSubmit)
        .then((response) => {
          let pdfWindow = window.open(' ');
          pdfWindow.document.write(
            "<html><head><title>PROPOSTAS POR PLANO</title></head><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
              encodeURI(response.data) +
              "'></iframe></html>"
          );
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    getSellers();
    getCategoryPlans();
    getProposalStatus();
  }, []);

  useEffect(() => {
    if (validation.values.categoryPlanInput.value) {
      getPlansByCategory(validation.values.categoryPlanInput.value);
    } else {
      setPlans([]);
    }
  }, [getPlansByCategory, validation.values.categoryPlanInput.value]);

  return (
    <ProposalsByPlanPage
      history={history}
      createData={createData}
      validation={validation}
      resetPlanInput={resetPlanInput}
      // Data
      plans={plans || []}
      sellers={sellers || []}
      categoryPlans={categoryPlans || []}
      statusOptions={statusOptions || []}
    />
  );
};
